"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "3.3.3.4", "build_date": "2024-10-01T14:57:44.669Z", "build_branch": "development", "build_commit": "9e7081c81d9d8c7d13fcced3b5e868a0cf516b7b" };
//# sourceMappingURL=build_data.js.map